import { writable, derived } from 'svelte/store';

export const activityLog = writable([]);

export function addLogEntry(message) {
    activityLog.update(log => [...log, { time: new Date(), message }]);
}

const LOCAL_STORAGE_KEY = 'flexFinderState';

const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
let initialState;
try {
    if(stored) {
        initialState = JSON.parse(stored);
    }
} catch (error) {
    // Error parsing stored state
}

if (!initialState) {
    initialState = {
        booking: null,
        customerId: null,
        token: null,
        expiresAt: null,
    };
}

export const bookingState = writable(initialState);

export const isLoggedIn = derived(
  bookingState,
  $bookingState => {
    // Check if the token is valid
    const { token, expiresAt } = $bookingState;
    if (!token || !expiresAt) return false;
    // expiresAt is in milliseconds (from Date.now() + expires_in * 1000)
    return Date.now() <= expiresAt;
  }
);

bookingState.subscribe((value) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(value));
  } catch (err) {
    // Error saving bookingState to localStorage
  }
});
